export async function loadFile(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener(
            'load',
            () => {
                resolve(reader.result);
            },
            false
        );
        reader.readAsDataURL(file);
    });
}
